<template>
  <div class="call-to-book">
    <div ref="header" class="call-to-book-header">
      <header-close :back="getBack" />
      <h6 class="title">{{tc('booking.callToBook')}}</h6>
    </div>
    <div
      class="call-to-book-body"
      :style="[{ height: scrollHeight + 'px' }]"
    >
      <picture
        class="image-wrapper"
        v-lazyload="{
          src: tc('booking.callToBookImage'),
          variant: 'call-to-book'
        }"
      >
        <img
          class="image"
          src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
          :alt="tc('booking.callToBookImageAlt')"
        />
      </picture>
      <div class="text">{{tc('booking.callToBookText')}}</div>
      <hr>
      <div class="hotel-info">
        <div class="name">{{hotelName}}</div>
        <div class="address" v-html="hotelAddress" />
        <div class="phone">
          <a :href="`tel:${hotelPhone}`">{{hotelPhone}}</a>
        </div>
      </div>
    </div>
    <div ref="footer" class="call-to-book-footer">
      <div class="confirmation-cta">
        <a :href="`tel:${hotelPhone}`" class="phone">
          {{tc('booking.callUs')}}
        </a>
        <a :href="`mailto:${hotelEmail}`" class="email">
          {{tc('formFields.email')}}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import TabTrapMixin from '@mixins/tab-trap'
import HeaderClose from "../header-close/header-close.vue"
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'call-to-book',
  components: {
    HeaderClose
  },
  mixins: [TabTrapMixin],
  inject: ['localQuery'],
  data: () => ({
    scrollHeight: 'auto',
  }),
  computed: {
    ...mapState('responsive', { wHeight: 'height' }),
    ...mapGetters('i18n', ['tc']),
    ...mapGetters('hotelData', ['getHotelById']),
    selectedHotel() {
      return this.getHotelById(this.localQuery.hotelCode)
    },
    hotelName() {
      return this.selectedHotel.fullHotelName || 'Property full name'
    },
    hotelAddress() {
      return `${this.selectedHotel.address || '5 Connaught Road Central'}<br>${this.selectedHotel.city || 'Hong Kong'}, ${this.selectedHotel.country || 'China'}`
    },
    hotelPhone() {
      return this.selectedHotel.phone || '+852 2522 0111'
    },
    hotelEmail() {
      return this.selectedHotel.email || 'contact@mandarinoriental.com'
    }
  },
  watch: {
    wHeight(val) {
      this.calculateScroll()
    }
  },
  mounted() {
    this.calculateScroll()
  },
  destroyed() {
    this.$emit('change-width', 'default')
  },
  methods: {
    getBack() {
      this.$emit('change-page', 'guests-and-rooms')
    },
    calculateScroll() {
      const footerHeight = this.$refs.footer?.getBoundingClientRect().height || 0
      const headerHeight = this.$refs.header?.getBoundingClientRect().height || 0
      this.scrollHeight = this.wHeight - footerHeight - headerHeight
    },
  }
}
</script>
